import { Component, Input, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { LocumsUtility } from 'src/app/locums/locums-utility';
import { UnitCertification } from 'src/app/locums/models/unit-certification.interface';
import { LocumsJobService } from 'src/app/locums/services/locums-job.service';

@UntilDestroy()
@Component({
    selector: 'nova-locums-recruiter-certifications',
    templateUrl: './locums-recruiter-certifications.component.html',
    styleUrls: ['./locums-recruiter-certifications.component.scss']
})
export class LocumsRecruiterCertificationsComponent implements OnInit {
    @Input() jobId: number;

    unitCertifications: UnitCertification[];
    getUnitCertificationsDetails = LocumsUtility.getUnitCertificationsDetails;

    constructor(private readonly locumsJobService: LocumsJobService) {}

    ngOnInit(): void {
        this.locumsJobService
            .getUnitCertifications(this.jobId)
            .pipe(untilDestroyed(this))
            .subscribe((certifications: UnitCertification[]) => {
                this.unitCertifications = certifications;
            });
    }
}
